import React from 'react';
import { LoaderWrapper, SpinnerWrapper } from 'src/domains/layouts/shared/loader/Loader.style';
import { observer } from 'src/utils/mobx-react';
import spinner from 'src/domains/layouts/shared/loader/Spinner.gif';
    
    interface LoaderPropsType {
        className?: string;
        isActive: boolean;
    }
    
export const Loader = observer('Loader', ({ className, isActive }: LoaderPropsType): JSX.Element | null => {
    if (isActive === false) {
        return null;
    }
    
    return (
        <LoaderWrapper className={className}>
            <SpinnerWrapper src={spinner} alt='spinner'/>
        </LoaderWrapper>
    );
    
});
